import { TasksClient } from "./tasks.js";
/**
 * Per-site custom roles (roles:manage). Permission keys are labels only; a role's
 * `capabilities` are allow-listed grants for assigned users (#1182).
 */
export class RolesClient extends TasksClient {
    async listTenantRoles(slug) {
        const res = await this.request("GET", `${this.siteBase(slug)}/roles`, undefined, true);
        return res.roles;
    }
    /** 409 `conflict` when the name or key already exists. */
    async createTenantRole(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/roles`, input, true);
    }
    async patchTenantRole(slug, id, input) {
        return this.request("PATCH", `${this.siteBase(slug)}/roles/${encodeURIComponent(id)}`, input, true);
    }
    /** Active staff names + roles, never contact data (staff:directory, #1183). */
    async getStaffDirectory(slug) {
        const res = await this.request("GET", `${this.siteBase(slug)}/staff/directory`, undefined, true);
        return res.staff;
    }
    /** roles:manage. */
    async getAccessSettings(slug) {
        return this.request("GET", `${this.siteBase(slug)}/access-settings`, undefined, true);
    }
    /** Owner only. 400 when a restricted capability is not grantable. */
    async patchAccessSettings(slug, input) {
        return this.request("PATCH", `${this.siteBase(slug)}/access-settings`, input, true);
    }
    /** Assign (`tenantRoleId`) or clear (`null`) a staff member's tenant role (employees:manage + hierarchy). */
    async assignStaffTenantRole(userId, tenantRoleId) {
        return this.request("PUT", `/v1/staff/${encodeURIComponent(userId)}/tenant-role`, { tenantRoleId }, true);
    }
    async listTenantPermissions(slug) {
        const res = await this.request("GET", `${this.siteBase(slug)}/permissions`, undefined, true);
        return res.permissions;
    }
    async createTenantPermission(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/permissions`, input, true);
    }
    async patchTenantPermission(slug, key, label) {
        return this.request("PATCH", `${this.siteBase(slug)}/permissions/${encodeURIComponent(key)}`, { label }, true);
    }
    /** Owner only. Extra capabilities lent to one person on top of their role, plus the grant/removal history (#1313). */
    async getCapabilityOverrides(userId) {
        return this.request("GET", `/v1/staff/${encodeURIComponent(userId)}/capability-overrides`, undefined, true);
    }
    /**
     * Owner only. Sets the person's extra capabilities to exactly `grants`
     * (omitted ones are removed; `[]` clears all). Grants only add to the role.
     * 400 on an unknown / owner-only capability or an `until` in the past; 404 for another site's user.
     */
    async setCapabilityOverrides(userId, grants) {
        return this.request("PUT", `/v1/staff/${encodeURIComponent(userId)}/capability-overrides`, { grants }, true);
    }
}
//# sourceMappingURL=roles.js.map